import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import style from './Navbar.module.css';
import './NavDefaultStyle.css';
import { getCities, getLanguages, getWebsiteSettings, getAreas } from '../../Api/commonApis';
import { getAllServices } from '../../Api/servcicesAPi';
import toggleIcon from '../../assets/icons/togglerIcon.svg';
import navbarArrow from '../../assets/icons/navbarArrow.svg';
import { filterLanguage } from './../../utilities/filterFunction';
import { host_url } from '../../configiration/config';
import { basename } from './../../configiration/config';
import logo from '../../assets/images/logo.png';
import closeIcon from '../../assets/icons/x-lg.svg';
import { imgResize } from './../../utilities/imageResize';
function Navbar() {
    const navbarCollapse = useRef();
    const { t, i18n } = useTranslation();
    const [services, setServices] = useState();
    const [websiteSettings, setwebsiteSettings] = useState({});
    const [areas, setAreas] = useState([]);
    const [searchObj, setSearchObj] = useState({ area: {} })
    const [languages, setLanguages] = useState([]);
    let locationLink = useRef();
    let servicesLink = useRef();
    const location = useLocation();


    useEffect(() => {
        let x = window.location.href;
        let u = x.split("/");
        let checkLocation = u.includes('areas');
        if (checkLocation) {
            locationLink.current.classList.add('goldenActiveLink');
        } else {
            locationLink.current.classList.remove('goldenActiveLink');
        }
        let checkServices = u.includes('our-services');
        if (checkServices) {
            servicesLink.current.classList.add('goldenActiveLink');
        } else {
            servicesLink.current.classList.remove('goldenActiveLink');
        }
    })

    // get website settings
    useEffect(() => {
        getWebsiteSettings().then((res) => {
            let settings = { ...websiteSettings }
            settings = res.data.data;
            setwebsiteSettings(settings);
            let sitename = filterLanguage(settings && settings.site_name && settings.site_name.locales)[0].title
            let tagline = filterLanguage(settings && settings.tag_line && settings.tag_line.locales)[0].title
            const title = document.querySelector("title");
            title.innerHTML = `${sitename} | ${tagline} `;
            const favicon = document.getElementById("websiteFavicon");
            favicon.href = settings.favicon ? `${host_url}/${settings && settings.favicon}` : logo;
        })
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (websiteSettings.meta_description !== null && websiteSettings.meta_keywords !== null) {
            if (location.pathname !== '/property-details/' || (location.pathname !== '/blogs//')) {
                const description = document.querySelector("meta[name='description']");
                description.setAttribute('content', websiteSettings.meta_description);
                const keywords = document.querySelector("meta[name='keywords']");
                keywords.setAttribute('content', websiteSettings.meta_keywords);
            }
        }
    }, [websiteSettings, location])

    // get areas
    useEffect(() => {
        getCities().then((res) => {
            let citiess = res.data.data;
            getAreas(citiess[0].slug).then((res) => {
                let areae = { ...areas }
                areae = res.data.data
                setAreas(areae)
                let search = { ...searchObj }
                setSearchObj({ ...search, area: areae })
            })
        })
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getAllServices().then(response => {
            if (response.data.status === true) {
                setServices(response.data.data.our_services)
            }
        })
            .catch(error => {
                console.log(error.response)
            });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        getLanguages().then((res) => {
            let langs = [...languages]
            langs = res.data.data
            setLanguages(langs)
        })
        let x = document.getElementsByClassName('nav-link')
        if (i18n.language === 'ar') {
            Array.from(x).forEach((el) => {
                el.classList.add('arabicNavbar')
            })
        }
        // eslint-disable-next-line
    }, [])

    function changeLanguage(lang) {
        if (lang === 'ar') {
            i18n.changeLanguage('ar')
            localStorage.setItem('i18nextLng', 'ar');
            window.location.reload();
        } else if (lang === 'en') {
            i18n.changeLanguage('en')
            localStorage.setItem('i18nextLng', 'en')
            window.location.reload();
        }
    }
    function closeOffCanvas(){
        navbarCollapse.current.click()
    }
    return (
        <React.Fragment>
            <nav className={`navbar navbar-expand-lg  py-0 ${style.navBar}`}>
                <div className={`${style.myCustomContainer} container`}>
                    <Link to={basename} className={`${style.navBrand}`}>
                        {websiteSettings && websiteSettings.logo &&
                            <img src={`${imgResize(websiteSettings.logo,85,85)}`} onError={(e) => { e.target.src = logo }} alt="logo_img" />
                        }
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offCanvasNavbar" aria-controls="offCanvasNavbar" aria-expanded="false" aria-label="Toggle navigation">
                        <span className={`navbar-toggler-icon ${style.togglerIcon}`}>
                            <img src={toggleIcon} alt='toggleIcon' />
                        </span>
                    </button>
                    <div  className={`offcanvas  navBarOffcanvas  ${i18n.language === 'en' ? 'offcanvas-start' : 'offcanvas-end'}`} id="offCanvasNavbar">
                        <div className={`d-flex justify-content-between align-items-center d-lg-none ${i18n.language === 'en' ? 'ms-lg-auto' : 'me-lg-auto'} p-2`}>
                            <Link to={basename} className={`${style.navBrand} m-0`}>
                                {websiteSettings && websiteSettings.logo &&
                                    <img src={`${imgResize(websiteSettings && websiteSettings.logo,57,57)}`} onError={(e) => { e.target.src = logo }} alt="logo_img" />
                                }
                            </Link>
                            <button ref={navbarCollapse} className="navbar-toggler" type="button" data-bs-dismiss="offcanvas" data-bs-target="#offCanvasNavbar" aria-controls="offCanvasNavbar">
                                <span className={`navbar-toggler-icon ${style.togglerIcon}`}>
                                    <img src={closeIcon} alt='..' style={{ width: '16px' }} />
                                </span>
                            </button>
                        </div>
                        <ul className={`navbar-nav mb-2 mb-lg-0 ${i18n.language === 'en' ? 'ms-lg-auto' : 'me-lg-auto'}`}>
                        <li className="nav-item" onClick={closeOffCanvas}>
                                <NavLink to={`${basename}/`} className={(navData) => navData.isActive ? `nav-link ${style.whiteNavLiks} goldenActiveLink` : `nav-link ${style.whiteNavLiks}`} aria-current="page" end={true}>{t('home')}</NavLink>
                            </li>
                            <li className="nav-item" onClick={closeOffCanvas}>
                                <NavLink to={`${basename}/about`} className={(navData) => navData.isActive ? `nav-link ${style.whiteNavLiks} goldenActiveLink` : `nav-link ${style.whiteNavLiks}`} aria-current="page" end={true}>{t('about')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <div className='dropdown'>
                                    <span ref={locationLink} className={`nav-link dropdown-toggle ${style.whiteNavLiks}`} id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">{t('locations')}</span>

                                    <ul className={`${style.dropDownList} dropdown-menu ${i18n.language === 'ar' && 'dropdown-menu-end'}`} aria-labelledby="navbarDropdownMenuLink">
                                        {areas && areas.map((area) => {
                                            let selectedArea = filterLanguage(area.locales)
                                            return (
                                                <li key={area.slug} onClick={closeOffCanvas} >
                                                    <NavLink
                                                        to={`${basename}/areas/${area.slug}`}
                                                        className={(navData) => navData.isActive ? `dropdown-item ${style.nestedDropDown} goldenActiveLink` : `dropdown-item ${style.nestedDropDown}`} >
                                                        {selectedArea.length > 0 ? selectedArea[0].name : ''}
                                                    </NavLink>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item ">
                                <div className='dropdown'>
                                    <span ref={servicesLink} className={`nav-link dropdown-toggle ${style.whiteNavLiks}`} id="navbarDropdownMenuLink2" role="button" data-bs-toggle="dropdown" aria-expanded="false">{t('our-services')}</span>

                                    <ul className={`${style.dropDownList} dropdown-menu ${i18n.language === 'ar' && 'dropdown-menu-end'}`} id="navbarDropdownMenuLink2" aria-labelledby="navbarDropdownMenuLink2">
                                        {services && services.map(service => {
                                            let selectedService = filterLanguage(service.locales)
                                            return (
                                                <li key={service.slug} onClick={closeOffCanvas}>
                                                    <NavLink to={`${basename}/our-services/${service.slug}`}
                                                        className={(navData) => navData.isActive ? `dropdown-item ${style.nestedDropDown} goldenActiveLink` : `dropdown-item ${style.nestedDropDown}`} >
                                                        {selectedService && selectedService.length > 0 && selectedService[0].title}
                                                    </NavLink>
                                                </li>
                                            )
                                        }
                                        )}
                                    </ul>
                                </div>
                            </li>

                            <li className="nav-item" onClick={closeOffCanvas}>
                                <NavLink to={`${basename}/blogs`} className={(navData) => navData.isActive ? `nav-link ${style.whiteNavLiks} goldenActiveLink` : `nav-link ${style.whiteNavLiks}`} aria-current="page">{t('blog')}</NavLink>
                            </li>
                            <li className="nav-item" onClick={closeOffCanvas}>
                                <NavLink to={`${basename}/contact-us`} className={(navData) => navData.isActive ? `nav-link ${style.whiteNavLiks} goldenActiveLink` : `nav-link ${style.whiteNavLiks}`} aria-current="page">{t('contact-us')}</NavLink>
                            </li>
                            <li className={`${style.listLink} nav-item`} onClick={closeOffCanvas}>
                                <NavLink to={`${basename}/list-your-property`} className={(navData) => navData.isActive ? `nav-link ${style.whiteNavLiks} goldenActiveLink` : `nav-link ${style.whiteNavLiks}`} aria-current="page">
                                    <span>{t('list-property')}</span>
                                </NavLink>
                            </li>
                            <li className={` ${style.langBtn} nav-item d-flex align-items-center cursor-pointer`}>
                                <div className="dropdown">
                                    <div className="d-flex align-items-center justify-content-start" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className={`text-white ${style.langWord}`}>{i18n.language === 'en' ? 'EN' : 'AR'}</span>
                                        <img src={navbarArrow} width='6' height='6' alt='arrow' className={style.dropDownArrow} />
                                    </div>
                                    <ul className={`${style.languageDropdown} dropdown-menu`} aria-labelledby="dropdownMenuButton1">
                                        {languages && languages.length > 0 && languages.map((lang) => {
                                            return (
                                                <li  key={lang.slug} onClick={() => changeLanguage(lang.slug)} className='d-flex text-align-center justify-content-between'>
                                                    <img src={`${imgResize(lang.image,30,30)}`} alt='language' />
                                                    <span> {lang.slug} </span>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>


                </div>
            </nav>
        </React.Fragment>
    )
}


export default Navbar